import { jsx as _jsx } from "react/jsx-runtime";
import shake from "../../../../../static/images/profile/prospre/Shake-375.jpg";
import broccoli from "../../../../../static/images/profile/prospre/Broccoli-375.jpg";
import tempeh from "../../../../../static/images/profile/prospre/Tempeh-375.jpg";
import steakSlice from "../../../../../static/images/profile/prospre/SteakSlice-375.jpg";
import brusselSprouts from "../../../../../static/images/profile/prospre/BrusselSprouts-375.jpg";
import mixedBerries from "../../../../../static/images/profile/prospre/MixedBerries-375.jpg";
import macaroniAndCheese from "../../../../../static/images/profile/prospre/MacaroniandCheese-375.jpg";
import toast from "../../../../../static/images/profile/prospre/Toast-375.jpg";
import yogurt from "../../../../../static/images/profile/prospre/Yogurt-375.jpg";
import greenBeans from "../../../../../static/images/profile/prospre/GreenBeans-375.jpg";
import almonds from "../../../../../static/images/profile/prospre/Almonds-375.jpg";
import peanuts from "../../../../../static/images/profile/prospre/Peanuts-375.jpg";
import cheeseOmelette from "../../../../../static/images/profile/prospre/CheeseOmelette-375.jpg";
import kaleSalad from "../../../../../static/images/profile/prospre/KaleSalad-375.jpg";
import mixedGreens from "../../../../../static/images/profile/prospre/MixedGreens-375.jpg";
import cauliflower from "../../../../../static/images/profile/prospre/Cauliflower-375.jpg";
import bacon from "../../../../../static/images/profile/prospre/Bacon-375.jpg";
import mixedVeggies from "../../../../../static/images/profile/prospre/MixedVeggies-375.jpg";
import asparagus from "../../../../../static/images/profile/prospre/Asparagus-375.jpg";
import bellPepper from "../../../../../static/images/profile/prospre/BellPepper-375.jpg";
import greenSmoothie from "../../../../../static/images/profile/prospre/GreenSmoothie-375.jpg";
import stirFry from "../../../../../static/images/profile/prospre/StirFry-375.jpg";
import turkeySandwich from "../../../../../static/images/profile/prospre/TurkeySandwich-375.jpg";
import lentils from "../../../../../static/images/profile/prospre/Lentils-375.jpg";
import cottageCheese from "../../../../../static/images/profile/prospre/CottageCheese-375.jpg";
import cookedCauliflower from "../../../../../static/images/profile/prospre/CookedCauliflower-375.jpg";
import brownRice from "../../../../../static/images/profile/prospre/BrownRice-375.jpg";
import mixedNuts from "../../../../../static/images/profile/prospre/MixedNuts-375.jpg";
import banana from "../../../../../static/images/profile/prospre/Banana-375.jpg";
import salmon from "../../../../../static/images/profile/prospre/Salmon-375.jpg";
import cheeseAndCrackers from "../../../../../static/images/profile/prospre/CheeseandCrackers-375.jpg";
import bakedPotato from "../../../../../static/images/profile/prospre/BakedPotato-375.jpg";
import whiteRice from "../../../../../static/images/profile/prospre/WhiteRice-375.jpg";
import cherryTomato from "../../../../../static/images/profile/prospre/CherryTomato-375.jpg";
import turkeyBacon from "../../../../../static/images/profile/prospre/TurkeyBacon-375.jpg";
import tunaSandwich from "../../../../../static/images/profile/prospre/TunaSandwich-375.jpg";
import tofu1 from "../../../../../static/images/profile/prospre/Tofu-375-1.jpg";
import spinach from "../../../../../static/images/profile/prospre/Spinach-375.jpg";
import oatmeal from "../../../../../static/images/profile/prospre/Oatmeal-375.jpg";
import apple from "../../../../../static/images/profile/prospre/Apple-375.jpg";
import hardBoiledEgg from "../../../../../static/images/profile/prospre/HardBoiledEgg-375.jpg";
import bagel from "../../../../../static/images/profile/prospre/Bagel-375.jpg";
import orange2 from "../../../../../static/images/profile/prospre/Orange2-375.jpg";
import orange from "../../../../../static/images/profile/prospre/Orange-375.jpg";
import friedEgg from "../../../../../static/images/profile/prospre/FriedEgg-375.jpg";
import orange3 from "../../../../../static/images/profile/prospre/Orange3-375.jpg";
import pBandCracker from "../../../../../static/images/profile/prospre/PBandCracker-375.jpg";
import kiwi from "../../../../../static/images/profile/prospre/Kiwi-375.jpg";
import greenSmoothie1 from "../../../../../static/images/profile/prospre/GreenSmoothie-375-1.jpg";
import edamame from "../../../../../static/images/profile/prospre/Edamame-375.jpg";
import ham from "../../../../../static/images/profile/prospre/Ham-375.jpg";
import tofu from "../../../../../static/images/profile/prospre/Tofu-375.jpg";
import avocadoToast from "../../../../../static/images/profile/prospre/AvocadoToast-375.jpg";
import eggs from "../../../../../static/images/profile/prospre/Eggs-375.jpg";
import chicken from "../../../../../static/images/profile/prospre/Chicken-375.jpg";
import carrots from "../../../../../static/images/profile/prospre/Carrots-375.jpg";
import grapes from "../../../../../static/images/profile/prospre/Grapes-375.jpg";
import hummusPita from "../../../../../static/images/profile/prospre/HummusPita-375.jpg";
import gardenSalad from "../../../../../static/images/profile/prospre/GardenSalad-375.jpg";
import peas from "../../../../../static/images/profile/prospre/Peas-375.jpg";
import corn from "../../../../../static/images/profile/prospre/Corn-375.jpg";
import bellPepper1 from "../../../../../static/images/profile/prospre/BellPepper-375-1.jpg";
import chickenSandwich from "../../../../../static/images/profile/prospre/ChickenSandwich-375.jpg";
import yogurt1 from "../../../../../static/images/profile/prospre/Yogurt-375-1.jpg";
import sweetPotato from "../../../../../static/images/profile/prospre/SweetPotato-375.jpg";
import strawberries from "../../../../../static/images/profile/prospre/Strawberries-375.jpg";
const foodImages = {
    shake: shake,
    broccoli: broccoli,
    tempeh: tempeh,
    steak: steakSlice,
    "brussel sprouts": brusselSprouts,
    berries: mixedBerries,
    "mac and cheese": macaroniAndCheese,
    "macaroni and cheese": macaroniAndCheese,
    toast: toast,
    yogurt: yogurt,
    "green beans": greenBeans,
    almonds: almonds,
    peanuts: peanuts,
    omelette: cheeseOmelette,
    "kale salad": kaleSalad,
    "mixed greens": mixedGreens,
    cauliflower: cauliflower,
    bacon: bacon,
    "mixed veggies": mixedVeggies,
    asparagus: asparagus,
    "bell pepper": bellPepper,
    "green smoothie": greenSmoothie,
    stirfry: stirFry,
    "stir fry": stirFry,
    "stir-fry": stirFry,
    "turkey sandwich": turkeySandwich,
    lentils: lentils,
    "cottage cheese": cottageCheese,
    "cooked cauliflower": cookedCauliflower,
    "brown rice": brownRice,
    nuts: mixedNuts,
    banana: banana,
    salmon: salmon,
    "cheese and crackers": cheeseAndCrackers,
    "baked potato": bakedPotato,
    "white rice": whiteRice,
    rice: whiteRice,
    "cherry tomato": cherryTomato,
    "turkey bacon": turkeyBacon,
    "tuna sandwich": tunaSandwich,
    tofu1: tofu1,
    spinach: spinach,
    oatmeal: oatmeal,
    oat: oatmeal,
    oats: oatmeal,
    apple: apple,
    "hard-boiled egg": hardBoiledEgg,
    egg: hardBoiledEgg,
    bagel: bagel,
    orange2: orange2,
    orange: orange,
    "fried egg": friedEgg,
    orange3: orange3,
    "peanut butter and cracker": pBandCracker,
    kiwi: kiwi,
    greenSmoothie1: greenSmoothie1,
    edamame: edamame,
    ham: ham,
    tofu: tofu,
    "avocado toast": avocadoToast,
    eggs: eggs,
    chicken: chicken,
    carrots: carrots,
    grapes: grapes,
    "hummus pita": hummusPita,
    "garden salad": gardenSalad,
    peas: peas,
    corn: corn,
    bellPepper1: bellPepper1,
    "chicken sandwich": chickenSandwich,
    yogurt1: yogurt1,
    "sweet potato": sweetPotato,
    strawberries: strawberries,
};
/**
 * Finds the phrase from the list that appears first in the text string.
 *
 * @param text The text string to search within.
 * @param phrases An array of phrases to search for in the text.
 * @returns The phrase that appears first in the text, or null if none are found.
 */
function getBestPhoto(text) {
    const textLower = text.toLowerCase();
    const phrases = Object.keys(foodImages);
    let firstIndex = textLower.length;
    let firstPhrase = null;
    // Iterate through each phrase
    for (const phrase of phrases) {
        const index = textLower.indexOf(phrase);
        // Check if the current phrase exists in the text and appears before the current firstPhrase
        if (index !== -1 && index < firstIndex) {
            firstIndex = index;
            firstPhrase = phrase;
        }
    }
    // Return the first phrase found in the text, or null if none are found
    if (!firstPhrase) {
        return null;
    }
    return foodImages[firstPhrase];
}
const ImagePicker = ({ mealName, ...rest }) => {
    const photo = getBestPhoto(mealName);
    if (!photo) {
        return _jsx("div", { style: { height: "200px", background: "#eee" } });
    }
    return _jsx("img", { src: photo, ...rest });
};
export default ImagePicker;
